(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schnuller-konfigurator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('salty-chain-builder')) {
  customElements.define(
    'salty-chain-builder',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.items = [];
        this.selected = -1;
        this.drag = null;
        this.photoRequests = new WeakSet();

        this.list = this.querySelector('[data-list]');
        this.status = this.querySelector('[data-status]');
        this.error = this.querySelector('[data-error]');
        this.nameInput = this.querySelector('[data-name]');
        this.scroller = this.querySelector('[data-scroll]');

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;

          if (button.dataset.index !== undefined) {
            if (event.detail === 0) {
              this.selected = Number(button.dataset.index);
              this.updateSelection();
            }
            return;
          }

          const action = button.dataset.action;
                    if (action === 'letters-clear') {
            const items = this.items.filter(
              item => !item.letter
            );

            if (this.commit(items, -1)) {
              this.nameInput.value = '';
            }

            return;
          }
          if (
            action === 'motif-loop' ||
            action === 'motif-clip'
          ) {
            const item = this.items[this.selected];

            if (!item?.motif) {
              this.error.textContent =
                'Bitte zuerst eine Motivperle oben auf der Kette antippen.';
              return;
            }

            const facing = action === 'motif-clip'
              ? 'clip'
              : 'loop';

            const items = [...this.items];

            items[this.selected] = {
              ...item,
              motifFacing: facing,
              rotation2D: facing === 'clip' ? 180 : 0,
              mirror2D: false
            };

            this.commit(items, this.selected);
            return;
          }
          if (action === 'left' && this.selected > 0) {
            this.move(this.selected, this.selected - 1);
          } else if (
            action === 'right' &&
            this.selected >= 0 &&
            this.selected < this.items.length - 1
          ) {
            this.move(this.selected, this.selected + 1);
} else if (
  (action === 'remove' || action === 'remove-direct') &&
  this.selected >= 0
) {            const items = this.items.filter(
              (_, index) => index !== this.selected
            );

            this.commit(
              items,
              Math.min(this.selected, items.length - 1)
            );
          } else if (action === 'clear') {
            this.nameInput.value = '';
            this.commit([], -1);
          } else if (action === 'name') {
            this.applyName();
          } else if (action === 'finish') {
            this.showFinal();
          } else if (action === 'back') {
            this.showEditor();
          }
        });

        this.list.addEventListener('keydown', event => {
          const button = event.target.closest('[data-index]');
          if (!button) return;

          const from = Number(button.dataset.index);
          let target = from;

          if (event.key === 'ArrowLeft') {
            target = Math.max(0, from - 1);
          } else if (event.key === 'ArrowRight') {
            target = Math.min(this.items.length - 1, from + 1);
          } else {
            return;
          }

          event.preventDefault();
          this.move(from, target);

          this.list.querySelector(
            `button[data-index="${target}"]`
          )?.focus({ preventScroll: true });
        });
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-letter-style]')) return;

          if (
            this.nameInput.value.trim() ||
            this.items.some(item => item.letter)
          ) {
            this.applyName();
          }
        });
                this.nameInput.addEventListener('input', event => {
          if (event.isComposing) return;
          this.applyName();
        });

        this.nameInput.addEventListener('compositionstart', () => {
          this.namePendingInvalid = true;

          this.querySelector(
            '[data-action="finish"]'
          ).disabled = true;
        });

        this.nameInput.addEventListener('compositionend', () => {
          this.applyName();
        });
        
/* Doppelname: zwei getrennte Perlenreihen */

this.doubleRows = {
  lower: {
    items: this.items,
    name: this.nameInput.value,
    selected: this.selected
  },
  upper: {
    items: [],
    name: '',
    selected: -1
  }
};

this.activeChainRow = 'lower';
this.doubleMode = false;

const upperHost = this.querySelector('[data-double-upper]');
const lowerHost = this.querySelector('[data-double-lower]');
const upperWrap = this.querySelector('[data-double-top]');
const rowSwitch = this.querySelector('[data-double-switch]');

const originalCommit = this.commit.bind(this);
const originalRender = this.render.bind(this);
const originalFinal = this.showFinal.bind(this);

const saveRow = () => {
  const state = this.doubleRows[this.activeChainRow];

  state.items = this.items;
  state.name = this.nameInput.value;
  state.selected = this.selected;
};

const previewRow = () => {
  const copy = this.list.cloneNode(true);

  copy.removeAttribute('data-list');
  copy.classList.add('scb-double-preview');

  copy.querySelectorAll('[data-delete-direct]')
    .forEach(button => button.remove());

  copy.querySelectorAll('button').forEach(button => {
    button.disabled = true;
    button.removeAttribute('data-index');
    button.removeAttribute('data-action');
  });

  return copy;
};

this.doubleGetData = () => {
  saveRow();

  const lower = [...this.doubleRows.lower.items];
  const upper = this.doubleMode
    ? [...this.doubleRows.upper.items]
    : [];

  return {
    mode: this.doubleMode ? 'double' : 'single',
    lower,
    upper,
    lowerMm: this.total(lower),
    upperMm: this.total(upper)
  };
};

const refresh = () => {
  const data = this.doubleGetData();
  const upperActive = this.activeChainRow === 'upper';
  const used = this.total();
  const max = upperActive ? 100 : 150;

  this.status.textContent =
    `${upperActive ? 'Oberer' : 'Unterer'} Strang: ` +
    `${used} von ${max} mm belegt.`;

  if (!upperActive && used < 140) {
    this.status.textContent +=
      ` Noch mindestens ${140 - used} mm hinzufügen.`;
  }

  this.querySelector('[data-action="finish"]').disabled =
    data.lowerMm < 140 ||
    data.lowerMm > 150 ||
    (this.doubleMode && (
      data.upperMm <= 0 ||
      data.upperMm > 100
    )) ||
    Boolean(this.namePendingInvalid);

  this.querySelectorAll('[data-edit-row]').forEach(button => {
    button.setAttribute(
      'aria-pressed',
      String(button.dataset.editRow === this.activeChainRow)
    );
  });
};

const switchRow = target => {
  if (target === this.activeChainRow) return;

  if (this.namePendingInvalid) {
    this.error.textContent =
      'Bitte zuerst den Namen korrigieren.';
    return;
  }

  saveRow();

  const oldHost = this.activeChainRow === 'upper'
    ? upperHost
    : lowerHost;

  const newHost = target === 'upper'
    ? upperHost
    : lowerHost;

  // Die bisherige Reihe als Vorschau behalten.
  oldHost.replaceChildren(previewRow());

  // Die echte bearbeitbare Perlenliste verschieben.
  newHost.replaceChildren(this.list);

  this.activeChainRow = target;
  this.items = this.doubleRows[target].items;
  this.selected = this.doubleRows[target].selected;
  this.nameInput.value = this.doubleRows[target].name;

  this.namePendingInvalid = false;
  this.error.textContent = '';

  this.render();
};

this.doubleSwitch = switchRow;

// Maximal 100 mm oben, maximal 150 mm unten.
this.commit = (items, selected = this.selected) => {
  const max = this.activeChainRow === 'upper'
    ? 100
    : 150;

  if (this.total(items) > max) {
    this.error.textContent =
      `Maximal ${max} mm in diesem Strang erlaubt.`;
    return false;
  }

  const success = originalCommit(items, selected);

  if (success) {
    saveRow();
    refresh();
  }

  return success;
};

this.render = () => {
  originalRender();
  refresh();
};

// Beide Stränge vor der fertigen Ansicht prüfen.
this.showFinal = () => {
  const data = this.doubleGetData();

  if (data.lowerMm < 140 || data.lowerMm > 150) {
    this.error.textContent =
      'Der untere Strang muss 140–150 mm lang sein.';
    return;
  }

  if (this.doubleMode && (
    data.upperMm <= 0 ||
    data.upperMm > 100
  )) {
    this.error.textContent =
      'Der obere Strang muss zwischen 1 und 100 mm enthalten.';
    return;
  }

  if (this.activeChainRow === 'upper') {
    switchRow('lower');
  }

  // Vorhandene 3D-Vorschau öffnen.
  originalFinal();

  const host = this.querySelector('[data-three-host]');

  if (host) {
    host.saltyDoubleChain = data;
  }
};

// Buttons zum Wechseln der Reihe.
rowSwitch.addEventListener('click', event => {
  const button = event.target.closest('[data-edit-row]');
  if (!button) return;

  switchRow(button.dataset.editRow);
});

// Einzelname / Doppelname umschalten.
const updateMode = () => {
  this.doubleMode =
    this.querySelector('[data-chain-mode]:checked')
      ?.value === 'double';

  if (!this.doubleMode && this.activeChainRow === 'upper') {
    switchRow('lower');
  }

  upperWrap.hidden = !this.doubleMode;
  rowSwitch.hidden = !this.doubleMode;

  refresh();
};

this.querySelectorAll('[data-chain-mode]').forEach(radio => {
  radio.addEventListener('change', updateMode);
});

// Vorhandenes Drag-and-drop beibehalten.
this.setupDragging();
this.render();
updateMode();

      }

      total(items = this.items) {
        return items.reduce(
          (sum, item) => sum + Number(item.mm),
          0
        );
      }

            commit(items, selected = this.selected) {
        if (items.some(item =>
          !Number.isFinite(Number(item.mm)) ||
          Number(item.mm) <= 0
        )) {
          this.error.textContent =
            'Bei einer Perle fehlt ein gültiges Längenmaß.';
          return false;
        }

        if (this.total(items) > 150) {
          this.error.textContent =
            'Diese Auswahl überschreitet 150 mm. ' +
            'Entferne zuerst eine Perle oder einen Buchstaben.';
          return false;
        }

        this.items = items;
        this.selected = selected;
        this.error.textContent = '';
        this.render();

        return true;
      }move(from, to) {
        if (
          from < 0 ||
          to < 0 ||
          from >= this.items.length ||
          to >= this.items.length
        ) return;

        const items = [...this.items];
        const [item] = items.splice(from, 1);

        items.splice(to, 0, item);
        this.commit(items, to);
      }

                 applyName() {
        /*
          Großbuchstaben für die Perlen erzeugen,
          ohne beim Tippen den Cursor zu versetzen.
        */
        const name = this.nameInput.value
          .trim()
          .toUpperCase();

        const finishButton = this.querySelector(
          '[data-action="finish"]'
        );

        if (!/^[A-Z]*$/.test(name)) {
          this.namePendingInvalid = true;

          this.error.textContent =
  'Bitte nur Buchstaben von A bis Z eingeben. ' +
  'Umlaute und Sonderzeichen sind nicht erlaubt.';

          finishButton.disabled = true;
          return false;
        }

        if (Array.from(name).length > 12) {
          this.namePendingInvalid = true;

          this.error.textContent =
            'Bitte höchstens zwölf Buchstaben eingeben.';

          finishButton.disabled = true;
          return false;
        }

        const option = this.querySelector(
          '[data-letter-style]:checked'
        );

        const style = option?.value || 'creme';
        const color = option?.dataset.color || '#f2ebdf';
        const ink = option?.dataset.ink || '#945630';

        const letters = Array.from(name).map(character => ({
          label: 'Buchstabe ' + character,
          character,
          letter: true,
          letterStyle: style,
          color,
          ink,
          mm: 12
        }));

        /*
          Nur die bisherigen Namensbuchstaben ersetzen.
          Alle anderen Perlen bleiben erhalten.
        */
        const first = this.items.findIndex(
          item => item.letter
        );

        const items = this.items.filter(
          item => !item.letter
        );

        const at = first < 0
          ? items.length
          : Math.min(first, items.length);

        items.splice(at, 0, ...letters);

        this.namePendingInvalid = false;

        const success = this.commit(
          items,
          letters.length ? at : -1
        );

        if (!success) {
          this.namePendingInvalid = true;
          finishButton.disabled = true;
        }

        return success;
      }
      kind(item) {
        if (item.letter) return 'letter';
        if (item.motif) return 'motif';
        return 'material';
      }

      loadMaterialPhoto(item) {
        if (
          item.imageUrl ||
          item.letter ||
          item.motif ||
          !item.id ||
          !window.SaltyWoodPhotos ||
          this.photoRequests.has(item)
        ) return;

        this.photoRequests.add(item);

        /*
          Falls die Materialauswahl noch keine Bildadresse
          übergeben hat, das Holzfoto über die Perlen-ID laden.
        */
        window.SaltyWoodPhotos.get({
          code: item.id
        }).then(imageUrl => {
          if (!imageUrl) return;

          item.imageUrl = imageUrl;

          if (
            this.isConnected &&
            this.items.includes(item)
          ) {
            this.render();
          }
        }).catch(error => {
          this.photoRequests.delete(item);

          if (this.items.includes(item)) {
            this.error.textContent =
              'Ein Perlenbild konnte nicht geladen werden. ' +
              'Bitte die Perle entfernen und erneut hinzufügen.';
          }

          console.error(error);
        });
      }

            render() {
        const used = this.total();

        this.status.textContent = used < 140
          ? `${used} mm belegt · Noch mindestens ${140 - used} mm hinzufügen.`
          : `${used} mm belegt · Mindestlänge erreicht · Noch ${150 - used} mm möglich.`;

        this.list.replaceChildren();

        if (!this.items.length) {
          const empty = document.createElement('li');
          empty.className = 'scb-empty';
          empty.textContent = 'Hier erscheinen deine Perlen.';
          this.list.append(empty);
        }

        this.items.forEach((item, index) => {
          const row = document.createElement('li');
          row.dataset.row = String(index);

          const length = Number(item.mm);
          const code = String(item.id || '');

                                        const isSpacer =
            !item.letter &&
            !item.motif &&
            (
              item.shape === 'pumpkin' ||
              code.startsWith('kuerbis-') ||
              code.startsWith('blumel-') ||
              code.startsWith('zwischen-blume-') ||
              code.startsWith('mini-gepunktet-') ||
              code.startsWith('circlet-') ||
              code.startsWith('oval-silikon-') ||
              code.startsWith('oval-holz-')
            );

        


const width = item.letter
  ? 38
  : Math.max(10, length * 3);

row.style.setProperty(
  '--bead-width',
  width + 'px'
);

row.style.setProperty(
  '--bead-slot',
  isSpacer
    ? length * 3 + 'px'
    : Math.max(30, width + 4) + 'px'
);

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'scb-bead';
          button.dataset.index = String(index);
          button.dataset.kind = this.kind(item);

          button.setAttribute(
            'aria-label',
            `Platz ${index + 1}: ${item.label}, ${length} mm`
          );

          const visual = document.createElement('span');
          visual.setAttribute('aria-hidden', 'true');

                    if (item.letter) {
            if (!window.SaltyLetterModel) {
              throw new Error(
                'Das Snippet salty-buchstaben-modell fehlt.'
              );
            }

            const wood =
              item.letterStyle === 'holz';

            visual.style.background = 'transparent';
            visual.style.border = '0';
            visual.style.borderRadius =
              wood ? '18%' : '22%';

            visual.style.clipPath = 'none';
            visual.style.width = width + 'px';
            visual.style.maxWidth = '100%';
            visual.style.height = 'auto';
            visual.style.aspectRatio = '1';
            visual.style.overflow = 'hidden';

            const letterImage =
              document.createElement('img');

            letterImage.src =
              window.SaltyLetterModel.image(item);

            letterImage.alt = '';
            letterImage.draggable = false;

            letterImage.style.cssText = [
              'display:block',
              'width:100%',
              'height:100%',
              'object-fit:contain',
              'pointer-events:none',
              'user-select:none',
              '-webkit-user-select:none'
            ].join(';');

            visual.append(letterImage);

          } else if (item.motif) {
            /*
    Neue 15-mm-Motive als Bild von vorne
    und hinten in der 3D-Ansicht anzeigen.
  */
  
            const rect = item.imageRect || {
              width: 1,
              height: 1
            };

            const ratio =
              Number(rect.width) > 0 &&
              Number(rect.height) > 0
                ? Number(rect.width) / Number(rect.height)
                : 1;

            const pictureWidth = Math.min(
              84,
              56 * ratio
            );

            const pictureHeight =
              pictureWidth / ratio;

            row.style.setProperty(
              '--bead-width',
              pictureWidth + 'px'
            );

            row.style.setProperty(
              '--bead-slot',
              pictureWidth + 'px'
            );

            visual.style.width =
              pictureWidth + 'px';

            visual.style.height =
              pictureHeight + 'px';

            visual.style.maxWidth = '100%';
            visual.style.aspectRatio = String(ratio);
            visual.style.background = 'transparent';
            visual.style.borderRadius = '0';
            visual.style.clipPath = 'none';

            visual.style.transform =
              item.motifFacing === 'clip'
                ? 'rotate(180deg)'
                : 'rotate(0deg)';

            visual.style.transformOrigin = 'center';

          } else {
            const diameter =
              Number(item.height) || length;

            /*
              Zwischenperlen erhalten ihre tatsächliche
              Länge entlang der Schnur als Positionsbreite.
              Keine zusätzliche leere Mindestposition.
            */
            const pictureWidth = isSpacer
  ? length * 3
  : width;

            if (isSpacer) {
              row.style.setProperty(
                '--bead-width',
                pictureWidth + 'px'
              );

              row.style.setProperty(
                '--bead-slot',
                pictureWidth + 'px'
              );
            }

            visual.style.width =
              pictureWidth + 'px';

            visual.style.maxWidth = '100%';

            /*
              Das Seitenverhältnis bleibt auch beim
              Verkleinern auf schmalen Bildschirmen erhalten.
            */
            visual.style.height = 'auto';

            visual.style.aspectRatio =
              length + ' / ' + diameter;

            visual.style.background =
              item.color || '#c5b49b';

            visual.style.borderRadius =
              isSpacer ? '0' : '50%';

            visual.style.clipPath = 'none';
          }

          /*
            Vorhandene Fotos oder erzeugte Modellbilder
            innerhalb der jeweiligen Perlenposition anzeigen.
          */
          if (!item.letter && item.imageUrl) {
            visual.style.background = 'transparent';
            visual.style.border = '0';
            visual.style.borderRadius = '0';
            visual.style.clipPath = 'none';

            const image = document.createElement('img');
            image.src = item.imageUrl;
            image.alt = '';
            image.draggable = false;

            image.style.cssText = [
              'display:block',
              'width:100%',
              'height:100%',
              'object-fit:contain',
              'pointer-events:none',
              'user-select:none',
              '-webkit-user-select:none'
            ].join(';');
            /*
              Bei der goldenen Circlet die hellen
              Bildränder in der 2D-Ansicht beschneiden.
            */  
            


/* Goldene Zwischenperlenblume – nur 2D */
if (code === 'zwischen-blume-gold') {
  const goldWidth = length * 3;
  const goldHeight = 14 * 3;

  // Gleicher Perlenabstand wie andere Zwischenblumen
  row.style.setProperty('--bead-width', goldWidth + 'px');
  row.style.setProperty('--bead-slot', goldWidth + 'px');

  row.style.width = '';
  row.style.minWidth = '';
  row.style.maxWidth = '';
  row.style.flex = '';
  row.style.margin = '';
  row.style.padding = '';

  // Bildgröße
  visual.style.width = goldWidth + 'px';
  visual.style.height = goldHeight + 'px';
  visual.style.maxWidth = '100%';
  visual.style.aspectRatio = '5 / 14';
  visual.style.overflow = 'hidden';

  image.style.width = '100%';
  image.style.height = '100%';
  image.style.objectFit = 'fill';
  image.style.transform = 'none';

  // Transparente Ränder im Goldfoto entfernen
  const original = new Image();
  original.crossOrigin = 'anonymous';

  original.onload = () => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = original.naturalWidth;
      canvas.height = original.naturalHeight;

      const ctx = canvas.getContext('2d', {
        willReadFrequently: true
      });

      ctx.drawImage(original, 0, 0);

      const pixels = ctx.getImageData(
        0, 0, canvas.width, canvas.height
      ).data;

      let left = canvas.width;
      let right = -1;
      let top = canvas.height;
      let bottom = -1;

      for (let y = 0; y < canvas.height; y++) {
        for (let x = 0; x < canvas.width; x++) {
          const alpha =
            pixels[(y * canvas.width + x) * 4 + 3];

          if (alpha < 80) continue;

          left = Math.min(left, x);
          right = Math.max(right, x);
          top = Math.min(top, y);
          bottom = Math.max(bottom, y);
        }
      }

      if (right < left || bottom < top) return;

      const cropped = document.createElement('canvas');
      cropped.width = right - left + 1;
      cropped.height = bottom - top + 1;

      cropped.getContext('2d').drawImage(
        canvas,
        left, top,
        cropped.width, cropped.height,
        0, 0,
        cropped.width, cropped.height
      );

      image.src = cropped.toDataURL('image/png');
    } catch (error) {
      console.warn('Goldblume konnte nicht zugeschnitten werden', error);
    }
  };

  original.src = item.imageUrl;
}

            // Nur Holzperlen 12 und 16 mm:
// Die Lochachse verläuft waagerecht entlang der Schnur.
const woodId = String(item.id || '');

if (
  woodId.startsWith('holz12-') ||
  woodId.startsWith('holz16-')
) {
  visual.style.aspectRatio = '1';
  visual.style.borderRadius = '50%';
  visual.style.overflow = 'hidden';

  image.style.objectFit = 'cover';
  image.style.borderRadius = '50%';
  image.style.transform = 'rotate(90deg)';
}

visual.append(image);
          }
/*
  Neue Motivperlen:
  15 mm entlang der Schnur, 30 mm quer dazu.
*/
if (
  item.motif &&
  String(item.id || '').startsWith('motiv15-')
) {
  const pictureWidth = Number(item.mm) * 3;

  row.style.setProperty(
  '--bead-slot',
  '15px'
);

row.style.width = '15px';
row.style.minWidth = '15px';
row.style.maxWidth = '15px';
row.style.flex = '0 0 15px';
  visual.style.width = '100%';
  visual.style.height = 'auto';
  visual.style.maxWidth = '100%';
  visual.style.aspectRatio = '1 / 2';

  const motifImage = visual.querySelector('img');

  if (motifImage) {
    motifImage.style.objectFit = 'fill';
  }
}
          button.append(visual);
          row.append(button);

          const position = document.createElement('small');
          position.textContent = String(index + 1);
          row.append(position);

          this.list.append(row);
          this.loadMaterialPhoto(item);
        });

        this.querySelector(
          '[data-action="finish"]'
        ).disabled =
          used < 140 ||
          used > 150 ||
          Boolean(this.namePendingInvalid);

        this.updateSelection();
      }

      updateSelection() {
        const valid =
          this.selected >= 0 &&
          this.selected < this.items.length;
// Bisherigen direkten Löschen-Button entfernen.
this.list.querySelectorAll('[data-delete-direct]')
  .forEach(button => button.remove());

// Bei der ausgewählten Perle einen Button anzeigen.
if (valid) {
  const row = this.list.querySelector(
    `[data-row="${this.selected}"]`
  );

  if (row) {
    const deleteButton = document.createElement('button');

    deleteButton.type = 'button';
    deleteButton.dataset.action = 'remove-direct';
    deleteButton.dataset.deleteDirect = '';
    deleteButton.className = 'scb-delete-direct';
    deleteButton.textContent = 'Löschen';

    deleteButton.setAttribute(
      'aria-label',
      `${this.items[this.selected].label || 'Perle'} entfernen`
    );

    row.append(deleteButton);
  }
}
        this.list.querySelectorAll('[data-index]')
          .forEach(button => {
            button.setAttribute(
              'aria-pressed',
              String(
                valid &&
                Number(button.dataset.index) === this.selected
              )
            );
          });

        this.querySelector('[data-selection]').textContent = valid
          ? `Ausgewählt: ${this.items[this.selected].label} · ` +
            `Platz ${this.selected + 1}`
          : 'Tippe eine Perle an, um sie auszuwählen.';

        this.querySelector('[data-action="left"]').disabled =
          !valid || this.selected === 0;

        this.querySelector('[data-action="right"]').disabled =
          !valid || this.selected === this.items.length - 1;

        this.querySelector('[data-action="remove"]').disabled =
          !valid;
      }

      setupDragging() {
        this.list.addEventListener('pointerdown', event => {
          const button = event.target.closest('[data-index]');

          if (
            !button ||
            !event.isPrimary ||
            event.button !== 0
          ) return;

          const from = Number(button.dataset.index);

          this.drag = {
            id: event.pointerId,
            from,
            to: from,
            startX: event.clientX,
            startY: event.clientY,
            scroll: this.scroller.scrollLeft,
            row: button.closest('[data-row]'),
            moved: false
          };

          this.list.setPointerCapture(event.pointerId);
        });

        this.list.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;

          const dx = event.clientX - drag.startX;
          const dy = event.clientY - drag.startY;

          if (!drag.moved && Math.hypot(dx, dy) < 6) return;

          drag.moved = true;
          const bounds = this.scroller.getBoundingClientRect();

          if (event.clientX > bounds.right - 35) {
            this.scroller.scrollLeft += 16;
          } else if (event.clientX < bounds.left + 35) {
            this.scroller.scrollLeft -= 16;
          }

          const scrollDelta =
            this.scroller.scrollLeft - drag.scroll;

          drag.row.classList.add('scb-dragging');
          drag.row.style.transform =
            `translate(${dx + scrollDelta}px, ${dy}px)`;

          const others = [
            ...this.list.querySelectorAll('[data-row]')
          ].filter(row => row !== drag.row);

          let to = others.findIndex(row => {
            const rect = row.getBoundingClientRect();

            return event.clientX <
              rect.left + rect.width / 2;
          });

          if (to < 0) to = others.length;
          drag.to = to;

          this.list.querySelectorAll('.scb-drop')
            .forEach(row => row.classList.remove('scb-drop'));

          others[to]?.classList.add('scb-drop');
        });

        const finish = (event, cancel = false) => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;

          this.drag = null;

          if (this.list.hasPointerCapture(event.pointerId)) {
            this.list.releasePointerCapture(event.pointerId);
          }

          if (cancel) {
            this.render();
          } else if (drag.moved) {
            this.move(drag.from, drag.to);
          } else {
            this.selected = drag.from;
            this.updateSelection();
          }
        };

        this.list.addEventListener(
          'pointerup',
          event => finish(event)
        );

        this.list.addEventListener(
          'pointercancel',
          event => finish(event, true)
        );

        this.list.addEventListener('lostpointercapture', event => {
          if (this.drag) finish(event, true);
        });
      }

      showFinal() {         if (this.namePendingInvalid) {
          this.error.textContent =
            'Der eingegebene Name konnte noch nicht übernommen werden. ' +
            'Bitte prüfe den Namen und die verfügbare Kettenlänge.';
          return;
        }
        const length = this.total();

        if (length < 140 || length > 150) {
          this.error.textContent =
            'Bitte gestalte einen Perlenbereich zwischen 140 und 150 mm.';
          return;
        }

        this.querySelector('[data-editor]').hidden = true;
        this.querySelector('[data-final]').hidden = false;

        this.querySelector('[data-final-summary]').textContent =
          `${this.items.length} Elemente · ${length} mm ` +
          'im frei gestaltbaren Bereich.';

        const template = this.querySelector(
          '[data-three-template]'
        );

        this.querySelector('[data-three-host]').replaceChildren(
          template.content.cloneNode(true)
        );

        this.querySelector('[data-final-heading]').focus();
      }

      showEditor() {
        this.querySelector('[data-three-host]').replaceChildren();
        this.querySelector('[data-final]').hidden = true;
        this.querySelector('[data-editor]').hidden = false;
        this.querySelector('[data-action="finish"]').focus();
      }

      disconnectedCallback() {
        this.drag = null;
      }
    }
  );
}


/* Doppelname: Ansicht automatisch umschalten */

document.addEventListener('change', function(event) {
  if (!event.target.matches('[data-chain-mode]')) return;

  const builder = event.target.closest('salty-chain-builder');
  if (!builder) return;

  const isDouble = event.target.value === 'double';

  builder.classList.toggle('scb-double-active', isDouble);

  const upper = builder.querySelector('.double-upper-wrap');
  const controls = builder.querySelector('.double-controls');

  if (upper) upper.hidden = !isDouble;
  if (controls) controls.hidden = !isDouble;

  builder.doubleMode = isDouble;

  if (!isDouble && builder.activeChainRow === 'upper') {
    builder.doubleSwitch?.('lower');
  }

  builder.doubleUpdate?.();
});

/* SALTYLOOP – Nach-oben-Buttons */

(() => {
  function addScrollButtons() {
    document.querySelectorAll('salty-chain-builder').forEach(builder => {

      const selectors = [
        'details > summary',
        '[aria-expanded]',
        '.accordion__title',
        '.accordion__header'
      ];

      builder.querySelectorAll(selectors.join(',')).forEach(header => {
        if (header.querySelector('.salty-scroll-top')) return;
        if (header.closest('.salty-scroll-top')) return;

        const button = document.createElement('span');
        button.className = 'salty-scroll-top';
        button.textContent = '↑';
        button.title = 'Nach oben';

        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        button.setAttribute('aria-label', 'Nach oben scrollen');

        const scrollUp = event => {
          event.preventDefault();
          event.stopPropagation();

          builder.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        };

        button.addEventListener('click', scrollUp);

        button.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            scrollUp(event);
          }
        });

        header.appendChild(button);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addScrollButtons);

  document.addEventListener('shopify:section:load', addScrollButtons);

  if (document.readyState !== 'loading') {
    addScrollButtons();
  }
})();

/* Nach-oben-Buttons für weitere Perlen-Dropdowns */

(() => {
  const initButtons = () => {
    document.querySelectorAll('salty-chain-builder').forEach(builder => {
      const material = builder.querySelector('.scb-materialauswahl');
      if (!material) return;

      const headers = material.querySelectorAll(
        'summary, [aria-expanded], .accordion__title, ' +
        '.accordion__header, [class*="dropdown-toggle"], ' +
        '[class*="dropdown-header"], [class*="accordion-header"]'
      );

      headers.forEach(header => {
        if (header.querySelector('.salty-scroll-top')) return;
        if (header.closest('.salty-scroll-top')) return;

        const button = document.createElement('span');
        button.className = 'salty-scroll-top';
        button.textContent = '↑';
        button.title = 'Nach oben';

        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        button.setAttribute('aria-label', 'Nach oben scrollen');

        const scrollUp = event => {
          event.preventDefault();
          event.stopPropagation();

          builder.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        };

        button.addEventListener('click', scrollUp);

        button.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            scrollUp(event);
          }
        });

        header.appendChild(button);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initButtons);
  document.addEventListener('shopify:section:load', initButtons);

  if (document.readyState !== 'loading') {
    initButtons();
  }
})();

/* Größenangaben für Motivperlen */

(() => {
  const sizes = {
    M052: 20, M053: 20, M054: 20, M055: 20,
    M056: 20, M057: 20, M058: 20, M059: 20,
    M066: 20, M067: 20,

    M138: 30, M139: 30, M140: 30,
    M141: 30, M142: 30, M143: 30,
    M170: 30, M171: 30, M175: 30
  };

  function updateLabels() {
    document.querySelectorAll(
      'salty-chain-builder [data-material], ' +
      'salty-chain-builder [data-motif], ' +
      'salty-chain-builder [data-motif-code]'
    ).forEach(item => {
      const raw = [
        item.dataset.material,
        item.dataset.motif,
        item.dataset.motifCode
      ].filter(Boolean).join(' ').toUpperCase();

      const match = raw.match(/M[\s_-]?0*(\d{2,3})(?!\d)/);
      if (!match) return;

      const code = 'M' + match[1].padStart(3, '0');
      const size = sizes[code];
      if (!size) return;

      let label = item.querySelector('.salty-motif-size');

      if (!label) {
        label = document.createElement('span');
        label.className = 'salty-motif-size';
        item.appendChild(label);
      }

      label.textContent = size + ' mm';
    });
  }

  function init() {
    const builder = document.querySelector('salty-chain-builder');
    if (!builder) return;

    updateLabels();

    const observer = new MutationObserver(updateLabels);
    observer.observe(builder, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* SALTYLOOP – Perlenliste für Shopify-Bestellungen */

(() => {
  function getBuilder() {
    const builders = [
      ...document.querySelectorAll('salty-chain-builder')
    ];

    return builders.length === 1 ? builders[0] : null;
  }

  function describeItem(item, index) {
    const parts = [];

    parts.push((index + 1) + '. ');

    if (item.letter) {
      parts.push('Buchstabe ' + item.character);

      if (item.letterStyle) {
        parts.push(' – ' + item.letterStyle);
      }
    } else {
      parts.push(item.label || 'Unbekannte Perle');
    }

    if (item.id) {
      parts.push(' – ID: ' + item.id);
    }

    if (item.mm) {
      parts.push(' – ' + item.mm + ' mm');
    }

    return parts.join('');
  }

  function describeRow(items) {
    if (!items.length) return 'Keine Perlen';

    return items.map(describeItem).join('\n');
  }

  function getDesign() {
    const builder = getBuilder();
    if (!builder) return null;

    const data = typeof builder.doubleGetData === 'function'
      ? builder.doubleGetData()
      : {
          mode: 'single',
          lower: builder.items || [],
          upper: []
        };

    return {
      mode: data.mode === 'double'
        ? 'Doppelname'
        : 'Einzelname',

      lower: describeRow(data.lower || []),

      upper: data.mode === 'double'
        ? describeRow(data.upper || [])
        : ''
    };
  }

  function saveToForm(form) {
    if (!form || !form.matches('form')) return;
    if (!form.querySelector('[name="id"]')) return;

    const design = getDesign();
    if (!design) return;

    const properties = {
      'Namensart': design.mode,
      'Perlen – Unterer Strang': design.lower
    };

    if (design.mode === 'Doppelname') {
      properties['Perlen – Oberer Strang'] =
        design.upper;
    }

    form.querySelectorAll('[data-salty-order-property]')
      .forEach(input => input.remove());

    Object.entries(properties).forEach(([key, value]) => {
      const input = document.createElement('input');

      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      input.value = value;
      input.dataset.saltyOrderProperty = '';

      form.appendChild(input);
    });
  }

  function isProductForm(form) {
    return Boolean(
      form &&
      (
        form.matches('form[action*="/cart/add"]') ||
        form.closest('product-form')
      )
    );
  }

  // Vor dem Absenden des Produktformulars speichern.
  document.addEventListener('submit', event => {
    if (!isProductForm(event.target)) return;

    saveToForm(event.target);
  }, true);

  // Zusätzlich bei Warenkorb-Schaltflächen vorbereiten.
  document.addEventListener('click', event => {
    const button = event.target.closest(
      'button[type="submit"], input[type="submit"]'
    );

    if (!button) return;

    const form = button.form || button.closest('form');

    if (!isProductForm(form)) return;

    saveToForm(form);
  }, true);
})();

/* SALTYLOOP – Nach-oben-Button für alle Material-Dropdowns */

(() => {
  function addScrollButtons() {
    document.querySelectorAll('salty-chain-builder').forEach(builder => {
      const area = builder.querySelector('.scb-materialauswahl');
      if (!area) return;

      const headers = area.querySelectorAll(
        'details > summary'
      );

      headers.forEach(summary => {
        // Motivperlen-Button und vorhandene Buttons nicht doppeln.
        if (summary.querySelector('.salty-scroll-top')) return;

        // Nur Material-Dropdowns, nicht die Motivperlen.
        if (summary.closest('[data-editor-motifs]')) return;

        const button = document.createElement('span');
        button.className = 'salty-scroll-top';
        button.textContent = '↑';
        button.title = 'Nach oben';

        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        button.setAttribute(
          'aria-label',
          'Zum Anfang des Konfigurators scrollen'
        );

        function scrollUp(event) {
          event.preventDefault();
          event.stopPropagation();

          builder.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }

        button.addEventListener('click', scrollUp);

        button.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            scrollUp(event);
          }
        });

        summary.appendChild(button);
      });
    });
  }

  function init() {
    addScrollButtons();

    document.querySelectorAll(
      'salty-chain-builder .scb-materialauswahl'
    ).forEach(area => {
      if (area.dataset.scrollButtonsObserved) return;

      area.dataset.scrollButtonsObserved = 'true';

      const observer = new MutationObserver(() => {
        addScrollButtons();
      });

      observer.observe(area, {
        childList: true,
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();


  } catch(e) { console.error(e); }
})();
})();
